<p-overlayPanel #overlayPanel>
  <div *ngIf="initialized" class="flex gap-4">
    <div *ngIf="showCalendar">
      <p-calendar
        [inline]="true"
        [yearRange]="yearRange"
        [ngModel]="internalDate"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onCalendarDateChange($event)"
      >
      </p-calendar>
    </div>
    <div pFocusTrap style="width: 350px">
      <div class="flex flex-column justify-content-between h-full">
        <div>

          <div *ngIf="showDate" class="flex gap-3 p-fluid">
            <div class="w-3">
              <label for="date">Date</label>
              <input
                type="number"
                placeholder="-"
                pInputText
                inputId="date"
                [min]="1"
                [max]="31"
                [ngModel]="internalDate | date : 'd'"
                [ngModelOptions]="{ standalone: true }"
                (blur)="onDateChange('date', $event)"
                (focus)="onSelectText($event)"
              />
            </div>
            <div class="w-5">

              <label for="month">Month</label>

              <p-dropdown
                placeholder="-"
                class="mt-2"
                inputId="month"
                [options]="monthOptions"
                optionLabel="name"
                optionValue="value"
                [ngModel]="internalDate | date : 'L'"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="onDateChange('month', $event)"
                [filter]="true" 
                filterBy="name"
              ></p-dropdown>

            </div>
            <div class="w-4">

              <label for="year">Year</label>

              <p-dropdown
                placeholder="-"
                class="mt-2"
                inputId="year"
                [options]="yearOptions"
                optionLabel="name"
                optionValue="value"
                [ngModel]="internalDate | date : 'y'"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="onDateChange('year', $event)"
                [filter]="true" 
                filterBy="name"
              ></p-dropdown>

            </div>
          </div>

          <div *ngIf="showTime" class="flex gap-3 p-fluid mt-3">
            <div class="w-6">
              <label for="hour">Hour</label>

              <p-dropdown
                placeholder="-"
                class="mt-2"
                inputId="hour"
                [options]="hourOptions"
                optionLabel="name"
                optionValue="value"
                [ngModel]="internalDate | date : 'H'"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="onDateChange('hour', $event)"
              ></p-dropdown>
            </div>
            <div class="w-6">
              <label for="minute">Minute</label>

              <input
                type="number"
                placeholder="-"
                pInputText
                inputId="minute"
                [min]="0"
                [max]="59"
                [ngModel]="internalDate | date : 'm'"
                [ngModelOptions]="{ standalone: true }"
                (blur)="onDateChange('minute', $event)"
                (focus)="onSelectText($event)"
              />
            </div>
<!--             
            <div class="w-6 flex align-items-end w-1">
              <p-dropdown
                placeholder="-"
                class="flex-grow-1"
                placeholder="AM/PM"
                optionLabel="name"
                optionValue="value"
                [options]="amOrPmOptions"
                [ngModel]="internalDate | date : 'aa'"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="onAmPmChange($event)"
              ></p-dropdown>
            </div>
          -->
          </div>

          <div *ngIf="!showTime" class="flex gap-3 p-fluid mt-3">
            <div class="w-12">
              <p-card class="card-info w-full">
                <p class="text-center"><strong>Note:</strong> Use the button below to toggle the time inputs.</p>
                <!-- <p class="pt-3">Click <strong>"Show Time"</strong> to display them or <strong>"Hide Time"</strong> to hide them.</p> -->
              </p-card>
            </div>
          </div>

        </div>

        <div class="mt-3 flex p-fluid justify-content-between">
          <div>
            <p-button
              (onClick)="onClear()"
              styleClass="p-button-secondary"
              label="Clear"
            ></p-button>
          </div>
          <div>
            <p-button
              (onClick)="onShowTime()"
              styleClass="p-button-secondary"
              [label]="(this.showTime) ? 'Hide Time' : 'Show Time'"
            ></p-button>
          </div>
          <div class="flex gap-3 p-fluid">
            <p-button
              (onClick)="onCancel()"
              styleClass="p-button-secondary"
              label="Cancel"
            ></p-button>
            <p-button (onClick)="onOk()" label="OK"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-overlayPanel>

<div
  class="input-wrapper"
  (click)="overlayPanel.toggle($event)"
  [ngClass]="{ 'is-read-only': readonly ? true : false }"
>
  <input
    type="text"
    class="w-1"
    [placeholder]="placeholder"
    pInputText
    [readonly]="true"
    [(ngModel)]="displayDate"
    [ngModelOptions]="{ standalone: true }"
  />

  <button
    class="btn-options"
    [disabled]="readonly"
    type="button"
    pButton
    icon="pi pi-calendar"
    (click)="overlayPanel.toggle($event)"
  ></button>

</div>
